module.exports = __webpack_public_path__ + "media/images/svg/orange-24a25a80d562a8545ebed1a94aeedc0a.svg";